import { defineStore } from 'pinia';

/**
 * Global singleton emoji picker state.
 * Open it from anywhere via useEmojiPickerStore().Open({ anchorRect, onSelect, onClose }).
 * Mounted once in App.vue (GlobalEmojiPicker.vue).
 */
export const useEmojiPickerStore = defineStore({
    id: 'emojiPicker',
    state: () => ({
        isOpen: false,
        anchorRect: null,
        _onSelect: null,
        _onClose: null,
    }),
    actions: {
        Open({ anchorRect = null, onSelect = null, onClose = null } = {}) {
            // Close any previous instance cleanly before opening a new one
            if (this.isOpen) {
                this._invokeClose();
            }
            this.anchorRect = anchorRect;
            this._onSelect = onSelect;
            this._onClose = onClose;
            this.isOpen = true;
        },

        Select(emojiObj) {
            const cb = this._onSelect;
            this._reset();
            if (cb) cb(emojiObj);
        },

        Close() {
            if (!this.isOpen) return;
            this._invokeClose();
        },

        _invokeClose() {
            const cb = this._onClose;
            this._reset();
            if (cb) cb();
        },

        _reset() {
            this.isOpen = false;
            this.anchorRect = null;
            this._onSelect = null;
            this._onClose = null;
        },
    },
});
